var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 11.8334C2.77858 11.8334 0.166992 9.22183 0.166992 6.00008C0.166992 2.77833 2.77858 0.166748 6.00033 0.166748C9.22208 0.166748 11.8337 2.77833 11.8337 6.00008C11.8337 9.22183 9.22208 11.8334 6.00033 11.8334ZM6.00033 10.6667C7.238 10.6667 8.42499 10.1751 9.30016 9.29991C10.1753 8.42474 10.667 7.23776 10.667 6.00008C10.667 4.7624 10.1753 3.57542 9.30016 2.70025C8.42499 1.82508 7.238 1.33341 6.00033 1.33341C4.76265 1.33341 3.57566 1.82508 2.70049 2.70025C1.82532 3.57542 1.33366 4.7624 1.33366 6.00008C1.33366 7.23776 1.82532 8.42474 2.70049 9.29991C3.57566 10.1751 4.76265 10.6667 6.00033 10.6667ZM6.58366 6.00008H8.91699V7.16675H5.41699V3.08341H6.58366V6.00008Z",
    fill: "#6D6D73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.ca88807c0d263b81d1281af7dd6e7c0c.svg";
export { ForwardRef as ReactComponent };